import _defineProperty from "/home/runner/work/experian-public-site-tng/experian-public-site-tng/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { clocksNow, elapsed, ResourceType as ResourceTypeEnum, toServerDuration } from '@datadog/browser-core';
import { RumEventType } from '../../rawRumEvent.types';
import { sanitizeIfLongDataUrl } from './resourceUtils';
export function trackManualResources(lifeCycle, resourceTracker) {
  function startManualResource(url) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var startClocks = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : clocksNow();
    var _a;
    var lookupKey = (_a = options.resourceKey) !== null && _a !== void 0 ? _a : url;
    resourceTracker.start(lookupKey, startClocks, _objectSpread({
      url: url
    }, options));
  }
  function stopManualResource(url) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var stopClocks = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : clocksNow();
    var _a;
    var lookupKey = (_a = options.resourceKey) !== null && _a !== void 0 ? _a : url;
    var stopped = resourceTracker.stop(lookupKey, stopClocks, {
      context: options.context,
      type: options.type
    });
    if (!stopped) {
      return;
    }
    var duration = elapsed(stopped.startClocks.relative, stopClocks.relative);
    var rawRumEvent = {
      date: stopped.startClocks.timeStamp,
      type: RumEventType.RESOURCE,
      resource: {
        id: stopped.id,
        type: stopped.type || ResourceTypeEnum.OTHER,
        url: sanitizeIfLongDataUrl(stopped.url),
        duration: toServerDuration(duration),
        method: stopped.method,
        status_code: options.statusCode,
        size: options.size
      },
      _dd: {},
      context: stopped.context
    };
    lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, {
      rawRumEvent: rawRumEvent,
      startClocks: stopped.startClocks,
      duration: duration,
      domainContext: {
        isManual: true
      }
    });
  }
  return {
    startResource: startManualResource,
    stopResource: stopManualResource
  };
}